import React, { useState, useEffect } from 'react';
import "./ShopComp.css"
import { useNavigate } from 'react-router-dom';


import addtocard from "../../Assets/add-card.png"

function ShopComp() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState(() => {
    // Initialize cart from localStorage or start with an empty array
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item.id === product.id);

      if (existingProduct) {
        // Increase quantity if the product is already in the cart
        return prevCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        // Add new product to the cart with quantity 1
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
  };
  const navigate = useNavigate();

  useEffect(() => {
    // Simulate fetching data
    const fetchProducts = async () => {
      setLoading(true);
      // Mock data for products, you can replace this with API calls
      const productsData = [
        { id: 1, name: 'Classic Pomade', price: 19.99, description: 'A medium-hold pomade for a sleek, classic look.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 2, name: 'Beard Oil', price: 14.99, description: 'Condition and soften your beard with natural oils.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 3, name: 'Hair Clipper', price: 99.99, description: 'Professional-grade clipper with adjustable settings.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 4, name: 'Straight Razor', price: 29.99, description: 'Achieve a close shave with this stainless steel razor.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 5, name: 'Beard Balm', price: 16.99, description: 'Control frizz and shape your beard with ease.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 6, name: 'Shaving Brush', price: 12.99, description: 'Lather up with this soft, high-quality brush.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 7, name: 'Aftershave Lotion', price: 9.99, description: 'Soothing aftershave with a refreshing scent.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 8, name: 'Hair Styling Gel', price: 10.99, description: 'Strong hold for all-day styling without residue.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 9, name: 'Texturizing Powder', price: 15.99, description: 'Add volume and texture to any hairstyle.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 10, name: 'Scissors Set', price: 59.99, description: 'Professional-grade scissors for precise cuts.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 11, name: 'Beard Comb', price: 8.99, description: 'Tame and style your beard with ease.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 12, name: 'Shaving Cream', price: 11.99, description: 'Rich, creamy lather for a smooth shave.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 13, name: 'Hot Towel Warmer', price: 129.99, description: 'Give clients a luxurious experience with warm towels.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 14, name: 'Neck Duster Brush', price: 7.99, description: 'Remove loose hair after a fresh cut.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
        { id: 15, name: 'Barber Cape', price: 19.99, description: 'Protect clients’ clothes with this waterproof cape.', image: 'https://bullfrogbarbershop.com/cdn/shop/collections/Kit.webp?v=1697399865' },
      ];
      
      setProducts(productsData);
      setLoading(false);
    };
    fetchProducts();
  }, []);


  const goToDetails = (id) => {
    navigate(`/shop/product/${id}`);
  };
  console.log(cart)
  return (
    <div className="shop">
      <h1>Featured Products</h1>

      {loading ? (
        <p>Loading products...</p>
      ) : (
        <div className="product-list">
          {products.map((product) => (
            <div key={product.id} className="product">
              <img onClick={() => goToDetails(product.id)} src={product.image} alt={product.name} />
              <h2 onClick={() => goToDetails(product.id)}>{product.name}</h2>
              <p onClick={() => goToDetails(product.id)}>{product.description}</p>
              <div className='buttonsshop'>
              <p onClick={() => goToDetails(product.id)} id='price'>${product.price}</p>
              <img id='addtocard' onClick={() => addToCart(product)} src={addtocard} alt="addtocard" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ShopComp;
